import React from 'react';
import Rating, { RatingCount, Stars } from "../common/Rating";
import { Icon, Typography } from "../ecosystem";
import { AddressLink, PhoneLink } from "../ecosystem/mybswh";

const VerifyProviderProfile = ({
    photo,
    name,
    specialty,
    reviewCount,
    averageRating,
    address,
    phone,
    patientStatus,
    isMobile,
    isTablet,
    isXLTablet,
    isDesktop,
    isVideoVisit
}) => {

    const rating = <div className="verify-provider-profile__rating">
        {averageRating &&
            averageRating !== "" &&
            averageRating !== "0" && (
                <Rating
                    align="bottom"
                    isRatingCount
                    isAverageRatingCount
                    reviewCount={reviewCount}
                    starDimension="12px"
                    averageRating={averageRating}
                >
                    <Stars />
                    <RatingCount ratingCountClassName={isMobile ? "d-none" : ""} />
                </Rating>
            )}
    </div>;

    return (<div className="verify-provider-profile-container">
        <div className="verify-provider-profile__avatar">
            <div
                className="verify-provider-profile__photo"
                style={{ backgroundImage: `url(${photo})` }}
            />
            {!isXLTablet && rating}
        </div>
        <div className="verify-provider-profile__info">
            <div className="verify-provider-profile__label">
                <div className="verify-provider-profile__name">
                    {name}
                </div>
                <div className="verify-provider-profile__specialty">
                    {specialty}
                </div>
                {isXLTablet && rating}
            </div>

            {!isVideoVisit &&
                <div className="verify-provider-profile__address">
                    <AddressLink
                        address={address}
                        street1Key="locationStreet1"
                        street2Key="locationStreet2"
                        cityKey="locationCity"
                        stateKey="locationState"
                        zipKey="locationZip"
                        icon={{ size: 'small', color: `${!isMobile ? '$color-primary-a2' : ''}` }}
                        splitAddress={isMobile}
                    />
                </div>
            }

            <div className="verify-provider-profile__phone">
                <PhoneLink
                    phone={phone}
                    icon={{ size: 'small', color: `${!isMobile ? '$color-primary-a2' : ''}` }}
                />
            </div>
           
            <div className="verify-provider-profile__status">
                <div className="verify-provider-profile__status-icon">
                    <Icon name={patientStatus === "Established Patient" ? "patient" : "new-patient"} color={"$color-primary-a2"} size="small" />
                </div>
                <div className="verify-provider-profile__status-label">
                    {patientStatus
                        ? <Typography type="body-01">
                            {patientStatus}
                        </Typography>
                        : <Typography type="heading-01" color={"$color-secondary-a2"}>
                            -
                        </Typography>
                    }
                </div>
            </div>

            {isVideoVisit && 
                <div className="verify-provider-profile__status">
                    <div className="verify-provider-profile__status-icon">
                        <Icon name={"video-visit"} color={"$color-primary-a2"} size="small" />
                    </div>
                    <div className="verify-provider-profile__status-label">
                        <Typography type="body-01">
                          Video Visit
                        </Typography>
                    </div>
                </div>
            }
        </div>
    </div>);
}

export default VerifyProviderProfile;
